import { CandidateProfileDetailsResponse } from '../../api/user/model';
import { GET_CANDIDATE_PROFILE_DETAILS_URL } from '../../constants/apiUrls';
import { GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

export const useGetCandidateProfileDetails = () => {
  const getCandidateProfileDetails = async () => {
    const res = await axiosClient.get<CandidateProfileDetailsResponse>(
      GET_CANDIDATE_PROFILE_DETAILS_URL
    );

    return res.data;
  };

  return useCustomQuery(GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY, getCandidateProfileDetails);
};
